module.exports = __webpack_public_path__ + "static/media/wheels-2.442ff79c.png";